module.exports = __webpack_public_path__ + "static/media/vsw-logo.5dcf6816.svg";